import React, { useEffect, useState, useRef } from "react";
import {
  Card, Row, Col, Button, Input, Spinner
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import swal from "sweetalert";

import {
  PurchaseOrderList,
  _Delete
} from "../../ApiEndPoint/ApiCalling";

import {
  Completed_Order_Delete,
  Place_Order_Delete
} from "../../ApiEndPoint/Api";

const PurchaseInvoice = () => {
  const navigate = useNavigate();
  const gridApi = useRef(null);

  const [rowData, setRowData] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔥 FULL COLUMN DEFS (tumhare original wale)
  const columnDefs = [
    {
      headerName: "S.No",
      valueGetter: "node.rowIndex + 1",
      width: 70
    },
    {
      headerName: "Status",
      field: "status",
      width: 120,
      cellRenderer: (params) => {
        return params.value;
      }
    },
    {
      headerName: "Invoice No",
      field: "invoiceId",
      width: 150
    },
    {
      headerName: "Date",
      valueGetter: (params) =>
        params.data?.date?.split("T")[0],
      width: 120
    },
    {
      headerName: "Contact Number",
      field: "partyId.contactNumber",
      width: 150
    },
    {
      headerName: "Company Name",
      field: "partyId.CompanyName",
      width: 200
    },
    {
      headerName: "Owner Name",
      field: "partyId.ownerName",
      width: 200
    },
    {
      headerName: "Builty Number",
      field: "BuiltyNumber",
      width: 150
    },
    {
      headerName: "No Of Package",
      field: "NoOfPackage",
      width: 150
    },
    {
      headerName: "Vehicle No",
      field: "vehicleNo",
      width: 130
    },
    {
      headerName: "Tax",
      field: "Tax",
      width: 120
    },
    {
      headerName: "Amount",
      field: "amount",
      width: 120
    },
    {
      headerName: "Charges",
      field: "coolieAndCartage",
      width: 120
    },
    {
      headerName: "Round Off",
      field: "roundOff",
      width: 120
    },
    {
      headerName: "Grand Total",
      field: "grandTotal",
      width: 150
    },
    {
      headerName: "Actions",
      width: 120,
      cellRenderer: (params) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <Button
            size="sm"
            color="primary"
            onClick={() => navigate(`/view/${params.data._id}`)}
          >
            View
          </Button>

          <Button
            size="sm"
            color="danger"
            onClick={() =>
              handleDelete(params.data._id, params.data.status)
            }
          >
            Delete
          </Button>
        </div>
      )
    }
  ];

  // 🔥 FETCH DATA
  const fetchData = async () => {
    try {
      setLoading(true);

      const user = JSON.parse(localStorage.getItem("userData"));

      const res = await PurchaseOrderList(user._id, user.database);
      const list =
        res?.orderHistory?.filter(
          (o) => o.status?.toLowerCase() === "completed"
        ) || [];

      setRowData(list.reverse());
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };

  // 🔥 DELETE
  const handleDelete = (id, status) => {
    let url =
      status?.toLowerCase() === "completed"
        ? Completed_Order_Delete
        : Place_Order_Delete;

    swal("Delete?", "Are you sure?", {
      buttons: ["Cancel", "Delete"]
    }).then((ok) => {
      if (ok) {
        _Delete(url, id).then(() => fetchData());
      }
    });
  };

  // 🔥 GRID READY
  const onGridReady = (params) => {
    gridApi.current = params.api;
  };

  // 🔥 SEARCH
  const handleSearch = (val) => {
    gridApi.current.setQuickFilter(val);
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: 100 }}>
        <Spinner />
      </div>
    );
  }

  return (
    <Row>
      <Col sm="12">
        <Card className="p-2">

          {/* HEADER */}
          <Row>
            <Col>
              <h4>Purchase Invoice</h4>
            </Col>

            <Col className="text-end">
              <Button
                color="primary"
                onClick={() => navigate("/sales-and-purchases?view=create-invoice")}
              >
                Create Invoice
              </Button>
            </Col>
          </Row>

          {/* SEARCH */}
          <Row className="mt-2">
            <Col lg="4">
              <Input
                placeholder="Search..."
                onChange={(e) => handleSearch(e.target.value)}
              />
            </Col>
          </Row>

          {/* GRID */}
          <div
            className="ag-theme-alpine mt-2"
            style={{ height: 500 }}
          >
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              onGridReady={onGridReady}
              pagination
            />
          </div>

        </Card>
      </Col>
    </Row>
  );
};

export default PurchaseInvoice;